export const PRODUCT_IDENTITY = Object.freeze({
  name: 'Elasticnote',
  shortName: 'Elasticnote',
  domain: 'elasticnote.com',
  origin: 'https://www.elasticnote.com',
  docsUrl: 'https://www.elasticnote.com/docs',
  supportUrl: 'https://www.elasticnote.com/contact',
  protocol: 'web+elasticnote',
  storagePrefix: 'elasticnote:',
} as const);
